import type { Image, Range } from './common';
import { FAQ } from './prop';

interface ListingBase {
  id?: string;
  propId: string;
  title: string;
  images: Image[];
  ageGroup: AgeGroup;
  pauseBooking?: boolean;
  listingType: ListingType;
  // bookingType: BookingType;
}
export interface EventAndWorkshopListing extends ListingBase {
  listingType: ListingType.EVENT_AND_WORKSHOP;
  tags: string[];
  overview: string;
  highlight: string;
  faqs?: Array<FAQ>;
}

export interface RestaurantListing extends ListingBase {
  listingType: ListingType.RESTAURANT;
}

export interface SportsListing extends ListingBase {
  listingType: ListingType.SPORTS;
}

export type Listing = EventAndWorkshopListing | RestaurantListing | SportsListing;

export enum ListingType {
  EVENT_AND_WORKSHOP = 'EVENT_AND_WORKSHOP',
  RESTAURANT = 'RESTAURANT',
  SPORTS = 'SPORTS'
}

export enum BookingType {
  FIXED_TIME_SLOT = 'FIXED_TIME_SLOT',
  VARIABLE_TIME_SLOT = 'VARIABLE_TIME_SLOT',
  TICKET_BOOKING = 'TICKET_BOOKING'
}

export type AgeGroup = Range<number>;

export enum BookingSubType { // Could be reduntant for these types coz seesion could handle these
  SINGLE_DAY_SINGLE_SLOT,
  SINGLE_DAY_MULTI_SLOT_BOOK_SINGLE_SLOT,
  MULTI_DAY_SINGLE_SLOT,
  MULTI_DAY_SINGLE_SLOT_BOOK_SINGLE_SLOT,
  MUTLI_DAY_MULTI_SLOT_BOOK_SINGLE_SLOT,
  /**
   * 12th Oct(2-4, 6-8) 13th Oct(2-4, 6-8) // Sectect a session each day like 2-4 on 12th Oct and 6-8 on 13th Oct
   */
  MULTI_DAY_MULTI_SLOT_BOOK_SINGLE_SLOT_EACH_DAY
}

export const TICKET_LIMIT_PER_BOOKING = 5;
